/**
 * The tabs of My progress. A route's address is checked in the part of it that loads with every
 * page, so this stays away from the page's own code.
 */
export const PROGRESS_TABS = ["overview", "training", "diet", "body", "photos", "metrics"] as const;
export type ProgressTab = (typeof PROGRESS_TABS)[number];
